import React from 'react';
import { StoresContext } from '../contexts';
import { RootStore } from '../store';

export const useStores = (): RootStore => {
    return React.useContext(StoresContext);
};
